import React from 'react';
import { func, oneOf } from 'prop-types';
import photoUploadIcon from '../../../../assets/images/shared/camera@3x.png';
import tracksUploadIcon from '../../../../assets/images/icons/icon-activities-green.svg';
import routeUploadIcon from '../../../../assets/images/icons/upload-route-icon.svg';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const variants = {
  photos: {
    imgSrc: photoUploadIcon,
    header: StringConstantsMixin.strings.CONTRIBUTE.DRAG_PHOTOS_HERE,
    subText: StringConstantsMixin.strings.CONTRIBUTE.PNG_JPG_JPEG
  },
  tracks: {
    imgSrc: tracksUploadIcon,
    header: StringConstantsMixin.strings.CONTRIBUTE.DRAG_RECORDING_HERE,
    subText: StringConstantsMixin.strings.CONTRIBUTE.GPX_TPO_FIT_TCX
  },
  route: {
    imgSrc: routeUploadIcon,
    header: StringConstantsMixin.strings.CONTRIBUTE.DRAG_ROUTE_HERE,
    subText: StringConstantsMixin.strings.CONTRIBUTE.GPX_TPO_FIT_TCX
  }
};

const DropzonePad = ({ openDropzone, variant }) => {
  const { imgSrc, header, subText } = variants[variant];
  // using dangerouslySetInnerHTML because we have styling on text that needs to be translated
  return (
    <>
      <div className={styles.dropzone} onClick={openDropzone}>
        <div className={styles.dzContent}>
          <img src={imgSrc} alt="upload-icon" data-test-id="upload-icon" className={styles.initialImg} />
          <h2 dangerouslySetInnerHTML={header} data-test-id="dragRoute" className={styles.dzHeader} />
          <div className={styles.dzSubText}>{subText}</div>
        </div>
      </div>
      <div id="previewsContainer" className={styles.previewsContainer} />
    </>
  );
};

DropzonePad.propTypes = {
  openDropzone: func,
  variant: oneOf(['photos', 'tracks', 'route']).isRequired
};

DropzonePad.defaultProps = {
  openDropzone: () => {}
};

export default DropzonePad;
